import React from "react"
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Card, CardFooter, CardHeader, CardTitle, CardContent, CardDescription, CardAction, Button, Label, Input } from '../../shadcnComponents/ui'

export function RenameMenu(props) {
    function handleRename() {
        if (document.getElementById("file-name").value != "") {
            props.renameSelected(document.getElementById("file-name").value)
            document.getElementById('file-name').value = '';
            document.getElementById('file-name').required = false
            document.getElementById('rename-menu').classList.add('hidden');
            props.unsetNameToRename()
        } else {
            document.getElementById("file-name").required = true
        }
    }

    function closeDialogue() {
        document.getElementById('file-name').value = '';
        document.getElementById('file-name').required = false
        document.getElementById('rename-menu').classList.add('hidden');
        props.unsetNameToRename()
    }

    return (
        <div id='rename-menu' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    <CardTitle>Μετονομασία</CardTitle>
                    <CardDescription>
                        Δώστε ένα νέο όνομα
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { closeDialogue() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent>
                    <form>
                        <div className="flex flex-col gap-6">
                            <div className="grid gap-2">
                                <Label htmlFor="text">Όνομα</Label>
                                <Input
                                    onKeyDown={(e) => { if (e.key == 'Enter') { e.preventDefault(); handleRename() } }}
                                    id="file-name"
                                    type="text"
                                    placeholder="Νέο όνομα"
                                />
                            </div>
                        </div>
                    </form>
                </CardContent>
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button onClick={() => { handleRename() }} variant={'yes'} >
                        Μετονομασία
                    </Button>
                    <Button variant={'no'} onClick={() => { closeDialogue() }}>
                        Άκυρο
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default RenameMenu